(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[425],{

/***/ "TjaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nature", function() { return Nature; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Nature = function Nature(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 26 26"
  }, rest), title && __jsx("title", null, title), __jsx("g", {
    transform: "translate(-73.000000, -883.000000)"
  }, __jsx("g", {
    transform: "translate(56.000000, 174.000000)"
  }, __jsx("g", {
    transform: "translate(0.000000, 86.000000)"
  }, __jsx("g", {
    transform: "translate(14.000000, 618.000000)"
  }, __jsx("path", {
    d: "M11.1,9.1c0.3,0.3,2.6,2.8,3.4,3.5c3.6,3.4,7,5.3,11.6,5.4l1.3,0l-2.1,1.5l3.2,0.1l-1.3,0.8 c-3.3,2-6.4,3.1-9.2,3.3l0.6,1c0.1,0.1,0.1,0.3,0,0.4l0,0.1l-1.4,2l4.5,0c0.2,0,0.4,0.2,0.4,0.4l0,0.1c0,0.2-0.2,0.4-0.4,0.5 l-0.1,0H8.3c-0.2,0-0.4-0.2-0.4-0.5c0-0.2,0.2-0.4,0.4-0.5l0.1,0l4.8,0l2.6-2.3l0-1.2c-1.1-0.1-2.1-0.4-3.2-0.8 c-4.1-1.7-6.7-5.3-7.6-10.8c0,0,0,0,0,0l-1.6-1l1.7-1.5C6.7,7,8.8,6.8,11.1,9.1z M16.5,23.7l0,1.4c0,0.1,0,0.2-0.1,0.3 l-0.1,0.1l-2,1.8h1.8l1.6-2.3l-0.7-1.2C16.9,23.8,16.7,23.8,16.5,23.7z M5.6,10.1L5.6,10.1l-0.8,0.8l0.4,0.4 c0.3,0.1,0.5,0.4,0.6,0.7c0.9,5.2,3.3,8.5,7.1,10.1c1.5,0.6,3,0.9,4.7,0.8l0,0l0,0c2.4-0.1,5-0.9,7.9-2.5l-0.6,0 c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.3-0.1-0.7,0.2-1l0.5-0.3c-4.2-0.4-7.6-2.3-11-5.6c-0.8-0.8-3.1-3.2-3.4-3.5 C8.6,7.8,7,7.9,5.6,10.1z M8.1,10.2c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C7.5,10.4,7.8,10.2,8.1,10.2z"
  }))))));
};

/***/ })

}]);